import { useState, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import brandService from '../services/brand.service'

export const useBrands = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')

    // Fetch brands from API
    const { data: brands = [], isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['brands'],
        queryFn: brandService.getBrands,
    })

    // Filter brands based on search and status
    const filteredBrands = useMemo(() => {
        return brands.filter(brand => {
            const matchesSearch = brand.name.toLowerCase().includes(searchText.toLowerCase()) || 
                                  brand.description?.toLowerCase().includes(searchText.toLowerCase())
            const matchesStatus = statusFilter === 'all' || brand.status === statusFilter

            return matchesSearch && matchesStatus
        })
    }, [brands, searchText, statusFilter])

    return {
        brands: filteredBrands,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        totalBrands: brands.length,
        isLoading,
        isFetching,
        error,
        refetch,
    }
}
